module.exports = __webpack_public_path__ + "to-do.png?2225f542fa4dacec870192499162aef0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/to-do.png
// module id = 213
// module chunks = 0